<template>
  <div id="mb-game-controll-panel">
    <transition name="modal-fade">
      <mb-info v-if="showInfo" @closeInf="showInfo = false"></mb-info>
    </transition>
    <transition name="modal-fade">
      <mb-file :file-data="file" v-if="showFile" @closeInf="showFile = false"></mb-file>
    </transition>
    <div
      v-if="file.length > 0"
      class="icon-container"
      @mouseenter="fileIconHover = true"
      @mouseleave="fileIconHover = false"
    >
      <img draggable="false" class="pdf-icon controll-icon" :src="pdfIcon" @click="showFile = true" />
      <transition name="icon-fade">
        <img draggable="false" v-if="fileIconHover" class="controll-icon" :src="pdfIconOn" @click="showFile = true" />
      </transition>
    </div>
    <div
      v-if="gameData.item.info"
      class="icon-container"
      @mouseenter="infoIconHover = true"
      @mouseleave="infoIconHover = false"
    >
      <img draggable="false" class="info-icon controll-icon" :src="infoIcon" @click="showInfo = true" />
      <transition name="icon-fade">
        <img draggable="false" class="controll-icon" v-if="infoIconHover" :src="infoIconOn" @click="showInfo = true" />
      </transition>
    </div>
    <div
      v-if="!gameConfig.withoutReset"
      class="icon-container"
      @mouseenter="resetIconHover = true"
      @mouseleave="resetIconHover = false"
    >
      <img draggable="false" class="reset-icon controll-icon" @click="resetGame()" :src="resetIcon" />
      <transition name="icon-fade">
        <img draggable="false" v-if="resetIconHover" class="controll-icon" @click="resetGame()" :src="resetIconOn" />
      </transition>
    </div>
    <div class="icon-container-small" @mouseenter="exitIconHover = true" @mouseleave="exitIconHover = false">
      <img draggable="false" class="exit-icon controll-icon-small" @click="closeGame()" :src="exitIcon" />
      <transition name="icon-fade">
        <img
          draggable="false"
          v-if="exitIconHover"
          class="controll-icon-small"
          @click="closeGame()"
          :src="exitIconOn"
        />
      </transition>
    </div>
    <div
      v-if="stages.length > 1 && currentStage > 0"
      class="prv-icon"
      @mouseenter="nextIconHover = true"
      @mouseleave="nextIconHover = false"
    >
      <svg width="calc(1080px * 0.1)" id="prv" height="calc(1080px * 0.1)" viewBox="0 0 400 400" @click="prvGame()">
        <g>
          <rect id="canvas_background" fill="transparent" height="402" width="402" y="-1" x="-1" />
        </g>
        <g>
          <ellipse
            id="svg_9"
            :stroke="'rgba(255,255,255,.5)'"
            :fill="'rgba(255,255,255,.5)'"
            ry="156"
            rx="156"
            cy="199"
            cx="199"
            fill-opacity="0"
            stroke-width="29"
          />
          <path
            class="path"
            id="svg_12"
            :stroke="'rgba(255,255,255,.5)'"
            d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
            stroke-opacity="0"
            stroke-width="11"
            :fill="'rgba(255,255,255,.5)'"
          />
        </g>
      </svg>
    </div>
    <div
      v-if="stages.length > 1 && currentStage + 1 < stages.length"
      class="next-icon"
      @mouseenter="nextIconHover = true"
      @mouseleave="nextIconHover = false"
    >
      <svg width="calc(1080px * 0.1)" id="next" height="calc(1080px * 0.1)" viewBox="0 0 400 400" @click="nextGame()">
        <g>
          <rect id="canvas_background" fill="transparent" height="402" width="402" y="-1" x="-1" />
        </g>
        <g>
          <ellipse
            id="svg_9"
            :stroke="'rgba(255,255,255,.5)'"
            ry="156"
            rx="156"
            cy="199"
            cx="199"
            fill-opacity="0"
            stroke-width="29"
            :fill="'rgba(255,255,255,.5)'"
          />
          <path
            class="path"
            id="svg_12"
            d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
            stroke-opacity="0"
            stroke-width="11"
            :fill="'rgba(255,255,255,.5)'"
            :stroke="'rgba(255,255,255,.5)'"
          />
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
// import INFO from '../../config/info/tablice.js';
import MbInfo from './MbInfo/MbInfo';
import MbFile from './MbFile/MbFile';
import _ from 'lodash';

export default {
  props: {
    prevroute: {
      type: Object,
      default: function () {
        return null;
      },
    },
    file: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  name: 'mb-game-controll-panel',
  components: { MbInfo, MbFile },
  data: function () {
    return {
      nextIconHover: false,
      prvIconHover: false,
      fileIconHover: false,
      infoIconHover: false,
      resetIconHover: false,
      exitIconHover: false,
      showInfo: false,
      showFile: false,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },

  methods: {
    openUrl(linkUrl) {
      if (linkUrl) {
        if (this.$store.getters.isWeb) {
          let link = document.createElement('a');
          link.href = window.location.origin + '/' + linkUrl;
          link.download = linkUrl.substr(linkUrl.lastIndexOf('/') + 1);
          link.click();
        } else {
          this.$electron.shell.openExternal(link);
        }
      }
    },
    init() {},
    closeGame() {
      this.$store.commit('RESET_STAGES');
      if (this.prevroute) {
        this.$router.push({ name: this.prevroute.name, params: this.prevroute.params });
      } else {
        this.$parent.$emit('closeGame');
        // this.redirectMain();
      }
    },
    nextGame() {
      this.$emit('nextGame');
    },
    prvGame() {
      this.$emit('prvGame');
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    resetGame() {
      console.log('reset');
      this.$store.commit('RESET_GAME', true);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch {
        console.log('%cImgPath - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
    },
  },
  computed: {
    gameConfig() {
      return _.cloneDeep(Object.assign({}, this.gameData.item.gameConfig, { gamePath: this.gameData.item.gamePath }));
    },
    gameData() {
      return this.$store.getters.gameData;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    stages() {
      return this.$store.getters.stages;
    },
    currentStage() {
      return this.$store.getters.currentStage;
    },
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cExitIcon MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cExitIconOn MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    resetIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/reset-64px.png`);
      } catch {
        console.log(
          '%cResetIcon MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    resetIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/reset-on-64px.png`);
      } catch {
        console.log(
          '%cResetIconOn MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    infoIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/info-64px.png`);
      } catch {
        console.log(
          '%cInfoIcon MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    infoIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/info-on-64px.png`);
      } catch {
        console.log(
          '%cInfoIconOn MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    pdfIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/pdf-64px.png`);
      } catch {
        console.log(
          '%cPdfIcon MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    pdfIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/pdf-on-64px.png`);
      } catch {
        console.log(
          '%cPdfIconOn MbGameControllPanel- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
$break-large: 1400px
#mb-game-controll-panel
  position: absolute
  transition: .5s
  top: 0
  right: 0
  .icon-container-small, .icon-container
    display: inline-block
    position: relative
    margin-top: 25px
    margin-right: 30px
    width: 48px
    height: 48px

    .controll-icon, .controll-icon-small
      position: absolute
      top: 0
      left: 0
      width: 48px
      height: 48px
      transition: .5s
      // transform: scale(.9)
      cursor: pointer
    .controll-icon-small
      width: 32px
      height: 32px
      margin-top: 0px
      margin-left: 20px
    .exit-icon
      animation: 1s .3s iconShow 1 linear backwards
      width: 32px
      height: 32px
    .reset-icon
      animation: 1s .6s iconShow 1 linear backwards
    .info-icon
      animation: 1s .9s iconShow 1 linear backwards
    .pdf-icon
      animation: 1s 1.2s iconShow 1 linear backwards

  .next-icon
    right: 10px

  .prv-icon
    left: 10px
  .next-icon, .prv-icon
    width: 100px
    height: 100px
    transition: .5s
    animation: 1s 1.5s iconShow 1 linear backwards
    margin: 0
    padding: 0
    position: fixed
    top: calc(50% - 50px)
    .controll-icon, .controll-icon-small
      position: absolute
      top: 0
      left: 0
      width: 48px
      height: 48px
      transition: .5s
      cursor: pointer
@keyframes iconShow
  0%
    opacity: 0
    // transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
  transform: translateX(20%)
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
